import moment from "moment"

import { REQUIREMENT_DATA } from "../MembershipJourney/requirementData"
import { ARTICLE_PATHS } from "../MembershipJourney/utils/constants/articleUrls"
import { RECIPROCITY_APPLICATION_STATE } from "../../../utils/reciprocityApplication"

// Reciprocity candidates apply for the same Membership application the
// Associate journey ends with, so reuse its card title and the shared status copy.
const ENROLLMENT = REQUIREMENT_DATA.level3.requirements.enrollment

export const RECIPROCITY_APPLICATION_TITLE = ENROLLMENT.name

const formatElectionDate = electionDate => {
  const date = moment(electionDate, "YYYY-MM-DD", true)
  return date.isValid() ? date.format("MMMM D, YYYY") : null
}

const approvedMessage = electionDate => {
  const formatted = formatElectionDate(electionDate)
  if (!formatted) return ENROLLMENT.statuses.approved.message
  return `Your application is approved! You are scheduled for the ${formatted} election, and will receive an official email notification once your election is complete.`
}

/**
 * Card copy per state. `statusKey` picks the badge colors from the Membership
 * Journey status theme so the card reads like the Associate journey's
 * Membership Application requirement.
 */
export const reciprocityApplicationCopy = ({
  state,
  electionDate,
  canReapply,
}) => {
  switch (state) {
    case RECIPROCITY_APPLICATION_STATE.DRAFT:
      return {
        statusKey: "in_progress",
        label: "In Progress",
        message:
          "You've started your application for Membership. Pick up where you left off.",
        primaryActionText: "Resume Application",
      }
    case RECIPROCITY_APPLICATION_STATE.IN_REVIEW:
      return {
        statusKey: "submitted",
        label: ENROLLMENT.statuses.submitted.label,
        message: ENROLLMENT.statuses.submitted.message,
      }
    case RECIPROCITY_APPLICATION_STATE.APPROVED:
      return {
        statusKey: "approved",
        label: ENROLLMENT.statuses.approved.label,
        message: approvedMessage(electionDate),
        secondaryLinkText: ENROLLMENT.statuses.approved.secondaryLinkText,
        secondaryLinkUrl: ARTICLE_PATHS.ELECTION_SCHEDULE,
      }
    case RECIPROCITY_APPLICATION_STATE.ELECTED:
      return {
        statusKey: "complete",
        label: ENROLLMENT.statuses.complete.label,
        message: ENROLLMENT.statuses.complete.message,
      }
    case RECIPROCITY_APPLICATION_STATE.DENIED:
      return canReapply
        ? {
            statusKey: "denied",
            label: "Denied",
            message:
              "Your application was not approved. Your authorization is still active, so you may apply again.",
            primaryActionText: "Apply for Membership",
          }
        : {
            statusKey: "denied",
            label: "Denied",
            message:
              "Your application was not approved. To apply again, contact Membership Services.",
            showContact: true,
          }
    default:
      return null
  }
}
